import { AppResourcePage } from './app-resource-base';
import { branchSwitchOnResource } from './helpers/branch-switch';
import { createProjectView, ProjectLock } from '../projects/project-ui-adapter';
import { customElement } from 'lit/decorators.js';
import { getProjectContainer, getProjectContainerManager } from '../projects/project-ui-container-manager';
import { goStaticURL } from '../../../webmodule-common/other/ui/resource-resolver';
import { isEmptyOrSpace } from '../../../webmodule-common/other/ui/string-helper-functions';
import { ModalViewBase } from '../../../webmodule-common/other/ui/data-entry-screen-base';
import { NullPromise } from '../../../webmodule-common/interop/types/misc';
import { ResourceLocker } from '../common/resource-lock';
import { LangAppProjectPage } from '../../../localization/scripts/dealer-franchisee/pages/app-project-lang';

@customElement('app-project')
export class AppProjectPage extends AppResourcePage {
  async redirectPath(): NullPromise<string> {
    return '/projects';
  }

  async createModalEditor(id: string): NullPromise<ModalViewBase> {
    const container = getProjectContainer(id);
    if (isEmptyOrSpace(id)) id = container.projectId;

    const qm = getProjectContainerManager(container, () => !this.lock?.isLockOwner);
    if (!(await qm.needsProject())) return null;
    const branchId = qm.project.projectOwnerId;
    if (!(await branchSwitchOnResource(branchId, LangAppProjectPage.projectGlossary()))) return null;

    return await createProjectView(qm);
  }

  meta() {
    return {
      title: () => LangAppProjectPage.projectEditorTitle(),
      description: 'SoftTech dealer CPQ'
    };
  }

  protected createLock(id: string): ResourceLocker | undefined {
    return new ProjectLock(id, async () => {
      await this.view?.abandonAndClose(true);
      goStaticURL('/projects');
    });
  }
}
